import { render } from "./BackTopButton.vue?vue&type=template&id=42e456f7"
import script from "./BackTopButton.vue?vue&type=script&lang=js"
export * from "./BackTopButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__